import { useEffect, useState } from "react";

const STORAGE_KEY = "x_cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      setVisible(!v);
    } catch {
      setVisible(true);
    }
  }, []);

  const save = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, ts: Date.now() }));
    } catch {
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-3 sm:p-4">
      <div className="max-w-[1320px] mx-auto theme-surface rounded-3xl shadow-[0_18px_40px_-20px_rgba(0,0,0,0.22)] p-5 sm:p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="text-sm theme-text-primary leading-relaxed">
          We use cookies to improve your experience. By clicking “Accept”, you consent to our use of cookies.{" "}
          <a href="/cookie-policy" className="theme-text-accent font-semibold hover:underline">
            Cookie Policy
          </a>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
          <button type="button" className="btn-secondary justify-center" onClick={() => save("declined")} data-testid="cookie-decline">
            Decline
          </button>
          <button type="button" className="btn-primary justify-center" onClick={() => save("accepted")} data-testid="cookie-accept">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
